<app-modal-header
  [title]="title"
  (closeModal)="closeThisModal($event)"
></app-modal-header>

<div class="mx-5 mt-2 flex items-center justify-center mb-5">
  @if (fileType === 'PDF') {
    <app-pdf-viewer
      class="w-full"
      [base64Src]="base64"
      [filenameForDownload]="title"
    ></app-pdf-viewer>
  } @else if (fileType === 'VIDEO') {
    <video class="w-full rounded-xl" controls>
      <source [src]="'data:video/mp4;base64,'+base64">
    </video>
  } @else if (fileType === 'AUDIO') {
    <video class="w-full h-[50px]" controls>
      <source [src]="'data:audio/mp3;base64,'+base64" type="audio/mp3">
    </video>
  } @else {
    <img class="w-full rounded-xl" [src]="'data:image/png;base64,'+base64" alt="image">
  }
</div>
